var _size;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import colors from "../../colors";
import { EnumButtonSize } from "../ProductCard/types";
export var defaultTheme = {
  size: (_size = {}, _defineProperty(_size, EnumButtonSize.large, {
    width: '196px'
  }), _defineProperty(_size, EnumButtonSize.normal, {
    width: '196px'
  }), _defineProperty(_size, EnumButtonSize.small, {
    width: '136px'
  }), _size),
  borderRadius: 100,
  color: colors.pineGreen,
  bgColor: colors.paleTara,
  borderColor: colors.lightBluishGreen,
  fontSize: 500,
  fontWeight: '600',
  hover: {
    color: colors.white,
    bgColor: colors.pineGreen,
    borderColor: colors.pineGreen
  }
};